import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-pa-md"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Once their account is activated they can login to the app.", -1)
const _hoisted_3 = { class: "text-center q-mt-md q-gutter-sm" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "q-pa-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_CopyInviteLinkBtn = _resolveComponent("CopyInviteLinkBtn")!
  const _component_setup_reminder_toggle = _resolveComponent("setup-reminder-toggle")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    label: _ctx.label,
    color: _ctx.color,
    outline: "",
    loading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      (_ctx.isInvited)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_ctx.userType) + " has been emailed an invite to activate their account.", 1),
            _hoisted_2,
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_btn, {
                icon: "fa fa-share",
                label: "Resend Invite",
                color: "primary",
                class: "q-mb-sm",
                onClick: _ctx.resendInvite
              }, null, 8, ["onClick"]),
              (_ctx.isClient)
                ? (_openBlock(), _createBlock(_component_CopyInviteLinkBtn, {
                    key: 0,
                    "user-id": _ctx.userId,
                    class: "q-pt-xl"
                  }, null, 8, ["user-id"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.canToggleReminder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_q_separator, { class: "q-mt-md" }),
                  _createVNode(_component_setup_reminder_toggle, {
                    user: _ctx.user,
                    "onUpdate:user": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:user', $event))),
                    class: "q-py-md"
                  }, null, 8, ["user"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.userType) + " has activated their account and can login to the app. ", 1))
    ]),
    _: 1
  }, 8, ["label", "color", "loading"]))
}